import { format } from 'url';

import getConfig from 'next/config';
import NextLink, { LinkProps } from 'next/link';

const { publicRuntimeConfig } = getConfig();

const Link: React.FunctionComponent<LinkProps> = ({ children, ...props }) => (
  <NextLink
    {...props}
    as={`${publicRuntimeConfig.PLATFORM_PREFIX || ''}${format(props.href)}`}
  >
    {children}
  </NextLink>
);

export default Link;
